import { FinancialManagementRouteMap } from '@/new-router/financial-management'

const financeBill = () => import('@/views/Finance/financeBill')
const payBill = () => import('@/views/Finance/payBill')
const InvoiceApplication = () => import('@/views/Finance/InvoiceApplication')
const borrowBill = () => import('@/views/Finance/borrowBill')
const transferBill = () => import('@/views/Finance/transferBill')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  name: 'XXXX'                   翻译字段的标识
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
    permission: 'XXXX'           v-permission对应的字段名
  }
**/

export default [
  {
    path: '/finance',
    name: 'finance',
    component: Home,
    meta: {
      title: '财务报销',
      icon: 'icon-finance',
      showSubiems: false,
      sort: 12,
      permission: 'finance:root',
      modules: 'finance',
    },
    children: [
      {
        path: 'financeBill',
        name: 'financeBill',
        component: financeBill,
        meta: {
          title: '财务报销',
          active: ['financeBill'],
          permission: 'finance:reimbursement',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReimbursement],
        },
      },
      {
        path: 'payBill',
        name: 'payBill',
        component: payBill,
        meta: {
          title: '付款申请',
          active: ['payBill'],
          permission: 'payment:request',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReimbursement],
        },
      },
      {
        path: 'borrowBill',
        name: 'borrowBill',
        component: borrowBill,
        meta: {
          title: '借款审批',
          active: ['borrowBill'],
          permission: 'loan:approval',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReimbursement],
        },
      },
      {
        path: 'transferBill',
        name: 'transferBill',
        component: transferBill,
        meta: {
          title: '内部转账申请',
          active: ['transferBill'],
          permission: 'finance:transfer:apply',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReimbursement],
        },
      },
      {
        path: 'InvoiceApplication',
        name: 'invoiceApplication',
        component: InvoiceApplication,
        meta: {
          title: '发票申请',
          active: ['invoiceApplication'],
          permission: 'invoice:application',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReimbursement],
        },
      },
    ],
  },
]
